import { render, staticRenderFns } from "./SeasonalAdjustmentsList.vue?vue&type=template&id=08fd505c&scoped=true"
import script from "./SeasonalAdjustmentsList.vue?vue&type=script&lang=js"
export * from "./SeasonalAdjustmentsList.vue?vue&type=script&lang=js"
import style0 from "./SeasonalAdjustmentsList.vue?vue&type=style&index=0&id=08fd505c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fd505c",
  null
  
)

export default component.exports